var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "currency-bag-dollar-solid"), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Q3_icons",
    "data-name": "Q3 icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4,9.9l1.5-5.2A2,2,0,0,0,31,2.1h-.4L24,5.6,16.1,2h-.5a1.9,1.9,0,0,0-1.9,2.4l2.2,6C10,14.8,6,23.2,6,29.6,6,38.7,14.1,46,24,46s18-7.3,18-16.4C42,23,37.6,14.1,31.4,9.9ZM31,30.5a4.9,4.9,0,0,1-2,4,6.3,6.3,0,0,1-3,1.3V38a2,2,0,0,1-2,2,1.9,1.9,0,0,1-2-2V35.8A10.9,10.9,0,0,1,17.7,34a1.8,1.8,0,0,1-.3-2.6,2,2,0,0,1,2.8-.6,6.7,6.7,0,0,0,4.1,1.3h0c1.5,0,2.5-.6,2.5-1.4s0-1.1-3.3-1.8S17,27.1,17,23.4s2-4.7,5-5.3V16a1.9,1.9,0,0,1,2-2,2,2,0,0,1,2,2v2.2a12,12,0,0,1,3.1,1.3,1.9,1.9,0,0,1,.4,2.8,1.8,1.8,0,0,1-2.7.5,6.3,6.3,0,0,0-3.3-.9,3.4,3.4,0,0,0-1.8.4c-.3.3-.5.5-.5.9s0,1.1,3.5,1.8S31,26.8,31,30.5Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.bde858b0fddf4a4e2259d8d39010e84b.svg";
export { ForwardRef as ReactComponent };